import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Instructions = styled.p`
  font-size: 16px;
  color: #6B7C93;
  margin: 0;
`;

export const HelpText = styled.p`
  font-size: 14px;
  line-height: 100%;
  color: rgba(107, 124, 147, 0.54);;
`;

export const LinkContainer = styled(Link)`
  color: rgba(107, 124, 147, 0.54);;
`;

export const RadioText = styled.div`
  font-size: 16px;
  line-height: 24 px;
  color: #6B7C93;
`;


// WEBPACK FOOTER //
// src/components/SignUpForm/styles.js